import { Injectable } from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';

import { RequeteModel } from '../models/requete-model';

/**
 * Service de gestion des requ�tes HTTP en cours
 */
@Injectable({
  providedIn: 'root'
})
export class HttpInProgressService {

    /**
     * Constructeur
     */
    constructor() { }

    private subject = new BehaviorSubject<RequeteModel[]>([]);

    /**
     * Notifier le d�but de la requ�te
     * @param requete
     */
    notifierDebutRequete(requete: RequeteModel) {
        this.subject.next(this.subject.getValue().concat(requete));
    }

    /**
     * Notifier la fin de la requ�te
     * @param requete
     */
    notifierFinRequete(requete: RequeteModel) {
        let arr = this.subject.getValue();
        let index = arr.findIndex((value: RequeteModel) => {
            return value.Hash == requete.Hash;
        });
        if (index > -1) {
            arr.splice(index, 1);
            this.subject.next(arr);
        }
    }

    /**
     * Lister les requ�tes en cours
     */
    listerRequetesEnCours(): Observable<any> {
        return this.subject.asObservable();
    }
}
